import { render, staticRenderFns } from "./Block4.vue?vue&type=template&id=e8eb0b8c&scoped=true"
import script from "./Block4.vue?vue&type=script&lang=js"
export * from "./Block4.vue?vue&type=script&lang=js"
import style0 from "./Block4.vue?vue&type=style&index=0&id=e8eb0b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eb0b8c",
  null
  
)

export default component.exports